/*eslint indent: ["error", 2, { "SwitchCase": 1 }]*/
import BootstrapTable from 'react-bootstrap-table-next'
import PropTypes from 'prop-types'
import React from 'react'
import paginationFactory from 'react-bootstrap-table2-paginator'
import {filter, forEach, some} from 'lodash'
import { useState, useEffect } from 'react'
import gql from 'graphql-tag'
import { useMutation } from '@apollo/react-hooks'
import {sizeFormatter} from '../utils/fileSizeFunctions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { processStatusConstants } from '../utils/fileSizeFunctions'

const GROUP_PUBLISH_QUERY = gql`
  mutation publishGroupFiles($input: GroupPublishFilesInput) {
    publishGroupFiles(input: $input) {
      filename
      pathOnDisk
      message
      }
  }
`
export default function GroupFilePublishListTable({s3FileLists, itemId, show, setDisableDownload}) {
  const [selectedRows, setSelectedRows] = useState([])
  const files =forEach(filter(s3FileLists, function(f) { return !(f.published || (f.processStatus &&
    (f.processStatus === processStatusConstants.UPLOAD_FAILED ||
    f.processStatus === processStatusConstants.UPLOAD_SUCCESS ||
    f.processStatus === processStatusConstants.SCAN_FAILED)))
  }), (value, index) =>{
    value.index = index +1
  })
  console.dir(files)
  useEffect(()=>{
    setDisableDownload(selectedRows.length===0)
  },[selectedRows,setDisableDownload])

  const [publishGroupFiles, {loading, data}] = useMutation(
    GROUP_PUBLISH_QUERY,
    {
      variables: {
        input: {
          itemId:itemId,
          itemFiles: selectedRows.map(({name, pathOnDisk}) => {
            return {filename:name, pathOnDisk, action:'GroupPublish'}})
        }
      },
      fetchPolicy:'no-cache'
    })

  useEffect(()=>{
    if(!show){
      publishGroupFiles()
    }

  },[show,publishGroupFiles])

  const handleOnSelect = (row, isSelect) =>{
    if (isSelect) {
      setSelectedRows([...selectedRows, row])
    } else {
      setSelectedRows(selectedRows.filter(x => x.index !== row.index))
    }
  }

  const handleOnSelectAll = (isSelect, rows) =>{
    if (isSelect ) {
      setSelectedRows([...selectedRows, ...rows])
    } else {
      setSelectedRows(selectedRows.filter(x => !some(rows, x)))
    }
  }
  const getFileList = () => {
    if(loading) return <span ><FontAwesomeIcon icon={faSpinner} pulse/> &nbsp;Loading data</span>
    if(data) {
      // setValidDownloadUrls(data.getS3DownloadUrl)
      return data.publishGroupFiles.map((row, index) => {
        return  (<>{index===0?<div style={{wordWrap:'break-word'}}>The file will be moved to a public bucket. For large file, please note that it may take some time to complete.</div>:''}
          <br/><div key={index} style={{wordWrap:'break-word'}}>{row.filename}&nbsp; &nbsp;{row.message}</div>
        </>)
      })
    }
    return 'error'
  }

  const columns = [
    { dataField: 'name', text: 'File Name',
      headerStyle: (column, colIndex) => { return { width:'65%', textAlign:'center'} },
      sort: true,
      formatter: (cell, row) => {
        let length = itemId.length
        if(row.key)
          cell= row.key.substring(length+1)
        return (
          <div className="text-collapse">
            {cell}
          </div>
        )
      } },
    {
      dataField: 'location',
      text: 'Location',
      sort: false,
      formatter: (cell, row) => {
        let location=''
        if (row.published )
          location='SB Public Cloud'
        if(row.movedToS3) cell = 's3'

        switch(cell) {
          case 's3':
            return row.published?location:'SB Cloud'
          case 's3_backed':
            return row.published?'On Premise + SB Legacy Cloud + '+location:'On Premise + SB Legacy Cloud'
          //eslint-disable-next-line
          case 'disk':
            return row.published? 'On Premise + ' + location :'On Premise'
          default:
            return 'On Premise'
        }
      }
    },
    { dataField: 'size', text: 'File Size', formatter: sizeFormatter,
      headerStyle: (column, colIndex) => { return { width:'15%', textAlign:'center'} },
      sort: false
    }
  ]

  const selectRowProp = {
    mode: 'checkbox',
    clickToSelect: true,
    nonSelectableStyle: { backgroundColor: 'gray' },
    selected: selectedRows.map(row => row.index),
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
  }

  const paginationOpts = {
    page: 1,
    sizePerPage: 10,
    nextPageText: '>',
    prePageText: '<',
    showTotal: true,
    sizePerPageList: [{
      text: '5', value: 5
    }, {
      text: '10', value: 10
    }, {
      text: '20', value: 20
    }, {
      text: 'All', value: files.length
    }]
  }

  return (
    <div className="sb-table-listing">
      {show?<BootstrapTable
        responsive
        wrapperClasses="table-responsive"
        keyField='index'
        data={files || []}
        columns={columns}
        bordered={false}
        selectRow={selectRowProp}
        pagination={paginationFactory(paginationOpts)}
        noDataIndication="No Files Available"
        pr
      />:getFileList()}
    </div>
  )
}

GroupFilePublishListTable.propTypes = {
  id: PropTypes.string,
  s3FileLists: PropTypes.array,
  parentId: PropTypes.string,
  history: PropTypes.shape({
    listen: PropTypes.func,
    push: PropTypes.func,
  }),
  itemId: PropTypes.string,
  show: PropTypes.any,
  setDisableDownload: PropTypes.any,
  // setValidDownloadUrls: PropTypes.any
}

